'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _RouterActions = require('../../../core/actions/RouterActions');

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    route: _appStepRoutes2.default.JOIN_HUBSPOT_ACCOUNT,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.AccountRegistration, props)
      );
    },
    props: {
      handleSubmit: function handleSubmit() {
        return (0, _RouterActions.goToStep)(_appStepRoutes2.default.JOIN_HUBSPOT_USER);
      }
    },
    stepNumber: 0
  };
};

module.exports = exports['default'];